export default () => {

    const checkbox = document.getElementById('MembershipForm_MembershipForm_DifferentShipping');
    const fields = document.querySelectorAll('div.shipping-field');

    if (checkbox) {
        checkbox.addEventListener('change', () => {
           if (checkbox.checked) {
               for (const field of fields) {
                   field.style.display = 'block';
               }
           } else {
               for (const field of fields) {
                   field.style.removeProperty('display');
               }
           }
        });

        if (checkbox.checked) {
            for (const field of fields) {
                field.style.display = 'block';
            }
        }

    }
}
